import { Icon, IconProps } from "@chakra-ui/react";

function ScanIcon(props: IconProps) {
  return (
    <Icon
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96561 2.16666L7.16669 2.16666C7.62692 2.16666 8.00002 2.53975 8.00002 2.99999C8.00002 3.46023 7.62692 3.83332 7.16669 3.83332H7.00002C6.2862 3.83332 5.80096 3.83397 5.42589 3.86462C5.06054 3.89447 4.8737 3.94857 4.74337 4.01498C4.42977 4.17477 4.1748 4.42974 4.01501 4.74334C3.9486 4.87367 3.8945 5.06051 3.86465 5.42586C3.834 5.80093 3.83335 6.28617 3.83335 6.99999V7.16666C3.83335 7.62689 3.46026 7.99999 3.00002 7.99999C2.53978 7.99999 2.16669 7.62689 2.16669 7.16666L2.16669 6.96557C2.16668 6.29477 2.16667 5.74113 2.20352 5.29014C2.24179 4.82172 2.32392 4.39114 2.53 3.98669C2.84958 3.35948 3.35951 2.84955 3.98672 2.52997C4.39117 2.32389 4.82175 2.24176 5.29017 2.20349C5.74116 2.16664 6.2948 2.16665 6.96561 2.16666Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00002 13C3.46026 13 3.83335 13.3731 3.83335 13.8333V14C3.83335 14.7138 3.834 15.199 3.86465 15.5741C3.8945 15.9395 3.9486 16.1263 4.01501 16.2566C4.1748 16.5702 4.42977 16.8252 4.74337 16.985C4.8737 17.0514 5.06054 17.1055 5.42589 17.1354C5.80096 17.166 6.2862 17.1667 7.00002 17.1667H7.16669C7.62692 17.1667 8.00002 17.5398 8.00002 18C8.00002 18.4602 7.62692 18.8333 7.16669 18.8333H6.96561C6.2948 18.8333 5.74116 18.8333 5.29017 18.7965C4.82175 18.7582 4.39117 18.6761 3.98672 18.47C3.35951 18.1504 2.84958 17.6405 2.53 17.0133C2.32392 16.6088 2.24179 16.1783 2.20352 15.7098C2.16667 15.2588 2.16668 14.7052 2.16669 14.0344C2.16669 14.023 2.16669 14.0115 2.16669 14V13.8333C2.16669 13.3731 2.53978 13 3.00002 13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5742 3.86462C15.1991 3.83397 14.7138 3.83332 14 3.83332H13.8334C13.3731 3.83332 13 3.46023 13 2.99999C13 2.53975 13.3731 2.16666 13.8334 2.16666H14C14.0115 2.16666 14.023 2.16666 14.0344 2.16666C14.7052 2.16665 15.2589 2.16664 15.7099 2.20349C16.1783 2.24176 16.6089 2.32389 17.0133 2.52997C17.6405 2.84955 18.1505 3.35948 18.47 3.98669C18.6761 4.39113 18.7583 4.82172 18.7965 5.29014C18.8334 5.74113 18.8334 6.29477 18.8334 6.96557V7.16666C18.8334 7.62689 18.4603 7.99999 18 7.99999C17.5398 7.99999 17.1667 7.62689 17.1667 7.16666V6.99999C17.1667 6.28617 17.166 5.80093 17.1354 5.42586C17.1055 5.06051 17.0514 4.87367 16.985 4.74334C16.8252 4.42974 16.5703 4.17477 16.2567 4.01498C16.1263 3.94857 15.9395 3.89447 15.5742 3.86462Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 13C18.4603 13 18.8334 13.3731 18.8334 13.8333V14.0344C18.8334 14.7052 18.8334 15.2588 18.7965 15.7098C18.7583 16.1783 18.6761 16.6088 18.47 17.0133C18.1505 17.6405 17.6405 18.1504 17.0133 18.47C16.6089 18.6761 16.1783 18.7582 15.7099 18.7965C15.2589 18.8333 14.7052 18.8333 14.0344 18.8333H13.8334C13.3731 18.8333 13 18.4602 13 18C13 17.5398 13.3731 17.1667 13.8334 17.1667H14C14.7138 17.1667 15.1991 17.166 15.5742 17.1354C15.9395 17.1055 16.1263 17.0514 16.2567 16.985C16.5703 16.8252 16.8252 16.5702 16.985 16.2566C17.0514 16.1263 17.1055 15.9395 17.1354 15.5741C17.166 15.199 17.1667 14.7138 17.1667 14V13.8333C17.1667 13.3731 17.5398 13 18 13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16669 10.5C2.16669 10.0398 2.53978 9.66666 3.00002 9.66666H3.00835C3.46859 9.66666 3.84169 10.0398 3.84169 10.5C3.84169 10.9602 3.46859 11.3333 3.00835 11.3333H3.00002C2.53978 11.3333 2.16669 10.9602 2.16669 10.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91669 10.5C5.91669 10.0398 6.28978 9.66666 6.75002 9.66666H6.75835C7.21859 9.66666 7.59169 10.0398 7.59169 10.5C7.59169 10.9602 7.21859 11.3333 6.75835 11.3333H6.75002C6.28978 11.3333 5.91669 10.9602 5.91669 10.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4167 10.5C13.4167 10.0398 13.7898 9.66666 14.25 9.66666H14.2584C14.7186 9.66666 15.0917 10.0398 15.0917 10.5C15.0917 10.9602 14.7186 11.3333 14.2584 11.3333H14.25C13.7898 11.3333 13.4167 10.9602 13.4167 10.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66669 10.5C9.66669 10.0398 10.0398 9.66666 10.5 9.66666H10.5084C10.9686 9.66666 11.3417 10.0398 11.3417 10.5C11.3417 10.9602 10.9686 11.3333 10.5084 11.3333H10.5C10.0398 11.3333 9.66669 10.9602 9.66669 10.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1667 10.5C17.1667 10.0398 17.5398 9.66666 18 9.66666H18.0084C18.4686 9.66666 18.8417 10.0398 18.8417 10.5C18.8417 10.9602 18.4686 11.3333 18.0084 11.3333H18C17.5398 11.3333 17.1667 10.9602 17.1667 10.5Z"
        fill="currentColor"
      />
    </Icon>
  );
}

export default ScanIcon;
